export var FlowCompareResult;
(function (FlowCompareResult) {
    FlowCompareResult[FlowCompareResult["Unchanged"] = 0] = "Unchanged";
    FlowCompareResult[FlowCompareResult["MovedLeft"] = 1] = "MovedLeft";
    FlowCompareResult[FlowCompareResult["MovedRight"] = 2] = "MovedRight";
    FlowCompareResult[FlowCompareResult["ModifiedLeft"] = 3] = "ModifiedLeft";
    FlowCompareResult[FlowCompareResult["ModifiedRight"] = 4] = "ModifiedRight";
    FlowCompareResult[FlowCompareResult["Changed"] = 5] = "Changed";
    FlowCompareResult[FlowCompareResult["Removed"] = 6] = "Removed";
    FlowCompareResult[FlowCompareResult["New"] = 7] = "New";
})(FlowCompareResult || (FlowCompareResult = {}));
;
